import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';

@Component({
	selector: 'app-d-geo-location',
	templateUrl: './d-geo-location.component.html',
	styleUrls: ['./d-geo-location.component.css']
})
export class DGeoLocationComponent implements OnInit {
	@Input() formElement: any = {};
	@Input() formValue?: FormGroup;
	@Output() change = new EventEmitter();
	@Output() blur = new EventEmitter();
	value: any;
	labelClass: any = [];
	inputClass: any = [];
	rowClass = [];
	selectedLocation: string;
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	constructor() { }

	ngOnInit() {
		if (this.formElement || Object.keys[this.formElement] !== 0) {
			this._formatView();
			this.value = this.formElement.value || '';
			if (this.value) {
				this.inputValue = this.value;
			}
		}
	}

	openInMap() {
		const url = `http://maps.google.com/maps?z=12&t=m&q=50,60`;
		Helpers.openInNewTab(url);
	}

	setGeoLocation(event) {
		if (!event || !event.response) {
			this.inputValue = '';
			this.selectedLocation = '';
			this.makeDirty();
			this.onChange();
			return;
		}
		const location = event.data.geometry.location;
		const address_components = event.data.address_components || [];
		const components = address_components.reduce((total, c) => {
			c.types = c.types || [];
			c.types.map(type => { total[type] = c })
			return total
		}, {});
		location.formattedAddress = event.data.geometry.location.geolocation.formatted_address;
		location.components = components;
		this.inputValue = location;
		this.onChange();
	}

	onChange() {
		// if (val === undefined || Number.isNaN(val) || Helpers.compareObj(this.value, val)) {
		// 	return;
		// }
		// this.makeDirty();
		// this.inputValue = this.value;
		// // this.valueChange.emit(this.value);
		this.change.emit({
			name: this.formElement.name,
			value: this.value
		});
	}

	makeDirty() {
		if (this.formValue) {
			this.formValue.markAsDirty();
			this.formValue.markAsTouched();
		}
	}

	set inputValue(value) {
		this.value = value;
		if (this.formValue) {
			this.formValue.setValue(value);
		}
		this.selectedLocation = value.formattedAddress;
	}

	get inputValue() {
		return this.formValue.value
	}

	isDisabled() {
		return (this.formElement.disabled || this.formElement.readOnly) ? '' : null;
	}

	private _formatView() {
		this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
		const labelDiv = this.formElement.labelDiv;
		const inputDiv = this.formElement.inputDiv;
		let derivedLabelClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
		];
		let derivedInputClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
		];
		if (this.formElement.row) {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
			];
			derivedLabelClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
			);
		} else {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.flexRow
			];
			derivedInputClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
			derivedLabelClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);
	}


	// private _formatView() {
	// 	this.labelClass = ['col-form-label field-label'];
	// 	this.inputClass = [];
	// 	let derivedLabelClass = [];
	// 	let derivedInputClass = [];
	// 	if (this.formElement.align && this.formElement.align === 6) {
	// 		derivedLabelClass.push('col-md-4');
	// 		derivedInputClass.push('col-md-8');
	// 	} else {
	// 		derivedLabelClass.push('col-md-2');
	// 		derivedInputClass.push('col-md-10');
	// 	}
	// 	const labelDiv = this.formElement.labelDiv;
	// 	const inputDiv = this.formElement.inputDiv;
	// 	derivedLabelClass = [`col-md-${labelDiv}`];
	// 	derivedInputClass = [`col-md-${inputDiv}`];
	// 	if (this.formElement.row) {
	// 		this.rowClass = ['row'];
	// 		derivedLabelClass.push('right-text');
	// 	} else {
	// 		derivedInputClass = ['col-md-12'];
	// 		derivedLabelClass = ['col-md-12'];
	// 	}
	// 	this.inputClass = this.inputClass.concat(derivedInputClass);
	// 	this.labelClass = this.labelClass.concat(derivedLabelClass);
	// }

}
